import { NgModule } from '@angular/core';
import { ReplaceLineBreaksPipe } from './replace-line-breaks.pipe';
import { ShortNumberPipe } from './short-number.pipe';
import { SpaceCasePipe } from './space-case-pipe';
import { OrdinalNumberPipe } from './ordinal-number.pipe';
import { ProperNameCasePipe } from './proper-name-case.pipe';

@NgModule({
  declarations: [ReplaceLineBreaksPipe, ShortNumberPipe, SpaceCasePipe, OrdinalNumberPipe, ProperNameCasePipe],
  imports: [],
  exports: [ReplaceLineBreaksPipe, ShortNumberPipe, SpaceCasePipe, OrdinalNumberPipe, ProperNameCasePipe]
})
export class PipesModule {}
